import { object, mixed, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();

    return object().shape({
        catalog_document: string().required(REQUIRED_TEXT).nullable(), // Permitimos null si el campo no está seleccionado aún
        file: mixed()
            .required(REQUIRED_TEXT)
            .test('file-exists', REQUIRED_TEXT, (value) => value !== null), // Validar que haya un archivo
    });
};
